import { FormEvent, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signInAdmin } from '../../lib/admin-auth';
import '../../styles/admin-auth.css';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setError('');

    if (!email.trim() || !/^\S+@\S+\.\S+$/.test(email)) {
      setError('Enter a valid administrator email address.');
      return;
    }

    if (password.length < 8) {
      setError('Password must contain at least 8 characters.');
      return;
    }

    setSubmitting(true);
    try {
      await signInAdmin(email.trim(), password);
      navigate('/admin/services', { replace: true });
    } catch (requestError) {
      setError(requestError instanceof Error ? requestError.message : 'Unable to sign in.');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <main className="admin-auth-page">
      <section className="admin-auth-header" aria-labelledby="admin-login-title">
        <span className="admin-security-pill">MF_NAILEDIT ADMIN</span>
        <h1 id="admin-login-title">Secure studio access</h1>
        <p>Only approved studio administrators can manage pricing, photos, bookings and website content.</p>
      </section>

      <form className="admin-auth-card" onSubmit={handleSubmit} noValidate>
        <h2>Admin login</h2>
        <p className="admin-auth-copy">Sign in with the approved Supabase administrator account.</p>

        <label className="admin-field">
          <span>Email address <b aria-hidden="true">*</b></span>
          <input
            type="email"
            autoComplete="username"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            aria-describedby="admin-email-help"
            required
          />
          <small id="admin-email-help">Required</small>
        </label>

        <label className="admin-field">
          <span>Password <b aria-hidden="true">*</b></span>
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            aria-describedby="admin-password-help"
            required
          />
          <small id="admin-password-help">Required</small>
        </label>

        <aside className="admin-security-note">
          <span>SECURITY NOTE</span>
          <p>Only accounts listed in the protected admin profile table can enter the dashboard.</p>
        </aside>

        {error && <p className="admin-auth-error" role="alert">{error}</p>}

        <button className="button button-primary admin-signin" type="submit" disabled={submitting}>
          {submitting ? 'Signing in…' : 'Sign in'}
        </button>

        <Link className="admin-forgot-link" to="/admin/forgot-password">Forgot password</Link>
      </form>
    </main>
  );
}
